import { Interpolation, InterpolationFunction, StyledProps } from 'styled-components';
import { SermonThemeElementsCornerStyle } from '../../types/SermonThemeElementsTheme';

type CornerStyleMap = {
  [P in SermonThemeElementsCornerStyle]?: Interpolation<StyledProps<unknown>>;
};

type InterPolationFactory = <P = unknown>(map: CornerStyleMap) => InterpolationFunction<StyledProps<P>>;

/**
 * Factory function for generating a styled-components interpolation function
 * based on a provided mapping of SermonThemeElementsCornerStyle values.
 *
 * @param {CornerStyleMap} map - Mapping of
 * SermonThemeElementsCornerStyle values to corresponding styled-components interpolations.
 *
 * @returns {InterPolationFactory} An interpolation
 * function that retrieves the appropriate interpolation based on the current theme's
 * SermonThemeElements.Global.cornerStyle value.
 */
export const cornerStyleInterpolationFactory: InterPolationFactory = (map) => {
  return ({ theme }) => {
    return map[theme._sermonThemeElements.Global?.cornerStyle];
  };
};
